<template>
  <div class="kb-upload-overlay" @click.self="closeModal">
    <div class="kb-upload-modal" role="dialog" aria-modal="true" aria-labelledby="kbUploadTitle">
      <div class="kb-upload-head">
        <div>
          <span class="kb-upload-eyebrow">KNOWLEDGE BASE</span>
          <h5 id="kbUploadTitle" class="kb-upload-title">Upload Dokumen Knowledge Base</h5>
        </div>
        <button type="button" class="kb-upload-close" aria-label="Tutup" :disabled="isUploading" @click="closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="kb-upload-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Select License: <span class="text-danger">*</span></label>
                <multiselect v-model="selectedLicense" id="ajax" label="license_name" track-by="id"
                  placeholder="Cari atau Pilih License" open-direction="bottom" :options="licenseOptions"
                  :multiple="false" :searchable="true" :loading="isLoadingLicense" :internal-search="false"
                  :clear-on-select="true" :close-on-select="true" :options-limit="300" :limit="3"
                  :show-no-results="true" :custom-label="customLabelLicense" @search-change="asyncFindLicenseSelect"
                  :show-labels="false">

                  <template slot="option" slot-scope="{ option }">
                    <span>
                      {{ option.license_name }} ({{ option.license_phone_number }})
                      <i :class="option.is_online_status == 1 ? 'text-success' : 'text-danger'"
                        class="fa fa-signal"></i>
                    </span>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
              </div>
            </div>

            <div v-if="selectedLicense" class="col-md-12">
              <div class="kb-limit-line" :class="{ 'is-limit': licenseLimitReached }">
                <i class="fa fa-book"></i>
                Pemakaian Knowledge Base: <strong>{{ licenseKbCount }} dari 5</strong>
                <span v-if="licenseKbLoading"><i class="fa fa-spinner fa-spin"></i></span>
                <span v-if="licenseLimitReached">Batas tercapai. Hapus salah satu KB sebelum menambah file baru.</span>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label>Upload File Knowledge Base:</label>
                <div v-if="licenseLimitReached" class="alert alert-warning">
                  Lisensi ini sudah memiliki 5 KB. Penambahan KB keenam diblokir.
                </div>
                <ul class="upload-list" v-if="filesExtract.length">
                  <li v-for="file in filesExtract" :key="file.id" class="file-list">
                    <div class="upload-wrap">
                      <div class="file-name">
                        <img style="width: 30px" v-if="file.thumb" :src="file.thumb" />
                        {{ file.name }}
                      </div>
                      <div class="file-size">{{ formatSizes(file.size) }}</div>
                      <div class="file-close">
                        <span class="text-danger" v-if="file.error">{{ file.error }}</span>
                        <i v-else-if="file.success" class="text-success fa fa-check-circle"></i>
                        <a href="#" @click.prevent="$refs.uploadbcExtract.remove(file)" class="text-warning">
                          <i class="fa fa-trash-o"></i>
                        </a>
                      </div>
                    </div>
                    <div class="progress progress-xs progress-striped" v-if="file.active || file.progress !== '0.00'">
                      <div class="progress-bar bg-success" :style="{ width: file.progress + '%' }"></div>
                    </div>
                  </li>
                </ul>

                <file-upload-bc-extract v-if="!licenseLimitReached" class="btn btn-outline-secondary" :accept="acceptExtract"
                  :data="objFilesMessageHandlerExtract" :post-action="uploadUrl" :multiple="false" :headers="headers"
                  :drop="true" v-model="filesExtract" @input-filter="inputFilterExtract" @input-file="inputFileExtract"
                  ref="uploadbcExtract" :extensions="extensionsExtract">
                  <i class="fa fa-plus"></i> Select File Knowledge Base
                </file-upload-bc-extract>

                <p class="text-primary mt-2">
                  <small>
                    Support files: {{ extensionsExtract }} <br />
                    Max Size: 10MB
                  </small>
                </p>
                <div class="alert alert-warning">
                  AI Knowledge Base Engine hanya memproses konten tekstual. Input berupa image/gambar di dalam dokumen
                  akan difilter
                  dan tidak akan masuk ke dalam database pengetahuan.
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="kb-upload-footer">
        <span class="kb-upload-footer-note">
          <i class="fa fa-info-circle"></i>
          Upload akan diproses otomatis setelah file diterima server.
        </span>
        <button type="button" class="btn btn-outline-secondary" :disabled="isUploading" @click="closeModal">
          Batal
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { APICore } from "@/utils/servicesApi";
import { getXAuthToken } from "@/utils/auth";
import FileUpload from "vue-upload-component";
import Multiselect from "vue-multiselect";
import { formatSizes } from "@/utils/helper";
import { mapGetters } from "vuex";

require("vue-multiselect/dist/vue-multiselect.min.css");

export default {
  name: "add-historykb",
  components: {
    FileUploadBcExtract: FileUpload,
    Multiselect,
  },
  props: {
    initialLicense: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedLicense: null,
      licenseOptions: [],
      isLoadingLicense: false,
      licenseKbCount: 0,
      licenseKbLoading: false,
      licenseLimitReached: false,

      // Upload Configuration
      uploadUrl: process.env.VUE_APP_BASE_API + APICore() + "/omni/only-upload-filev3",
      filesExtract: [],
      acceptExtract: "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain",
      extensionsExtract: "pdf,doc,docx,txt",

      // Objek payload yang dikirim ke server saat upload file
      objFilesMessageHandlerExtract: {
        license_id: "", // Ditambahkan sesuai permintaan
        message_type: "document",
        is_extract_document: 1,
      },

      formParam: {
        license_id: "",
        file_url: ""
      },

      licenseListParam: {
        license_name: "",
        page: 0,
        perPage: 20,
      }
    };
  },
  computed: {
    ...mapGetters(["agentSession"]),
    headers() {
      return {
        "X-Auth-Token": "Bearer " + getXAuthToken(),
      };
    },
    isUploading() {
      return this.filesExtract.some((file) => {
        if (!file) return false;
        if (file.active) return true;
        return file.progress && file.progress !== "0.00" && !file.success && !file.error;
      });
    },
  },
  created() {
    this.initializeModal();
  },
  watch: {
    selectedLicense(val) {
      const id = val ? val.id : "";
      this.formParam.license_id = id;
      // Update license_id di payload upload file agar server tahu context license-nya
      this.objFilesMessageHandlerExtract.license_id = id;
      this.licenseKbCount = 0;
      this.licenseLimitReached = false;
      if (id) this.loadLicenseKbCount(id);
    }
  },
  methods: {
    customLabelLicense({ license_name, license_phone_number }) {
      return license_name ? `${license_name} – ${license_phone_number}` : '';
    },

    async initializeModal() {
      await this.asyncFindLicenseSelect("");
      if (!this.initialLicense) return;
      const matching = this.licenseOptions.find(
        (item) => String(item.id) === String(this.initialLicense.id)
      );
      this.selectedLicense = matching || this.initialLicense;
    },

    async asyncFindLicenseSelect(query) {
      this.isLoadingLicense = true;
      this.licenseListParam.license_name = query || "";
      try {
        const response = await this.$store.dispatch("license/getLicenseList", this.licenseListParam);
        this.licenseOptions = (response.data && response.data.data) || [];
      } catch (error) {
        this.licenseOptions = [];
      } finally {
        this.isLoadingLicense = false;
      }
    },

    closeModal() {
      if (this.isUploading) return;
      this.$emit("close");
    },

    resetForm() {
      this.filesExtract = [];
      this.selectedLicense = null;
      this.formParam.file_url = "";
    },

    async loadLicenseKbCount(licenseId) {
      this.licenseKbLoading = true;
      try {
        const response = await this.$store.dispatch("aiKey/knowledgeBaseSummary", {
          license_id: licenseId
        });
        if (this.formParam.license_id !== licenseId) return;
        this.licenseKbCount = Number(response.data && response.data.document_count) || 0;
        this.licenseLimitReached = this.licenseKbCount >= 5;
      } catch (error) {
        // Ringkasan Qdrant dapat gagal; fallback tetap menghitung record
        // histori lisensi secara eksak dan tidak memakai total lintas lisensi.
        try {
          const response = await this.$store.dispatch("aiKey/historyListKB", {
            page: 0,
            perPage: 200,
            columnFilters: { license_id: licenseId }
          });
          if (this.formParam.license_id !== licenseId) return;
          const rows = (response.data && response.data.data) || [];
          this.licenseKbCount = rows.filter((row) => String(row.license_id) === String(licenseId)).length;
          this.licenseLimitReached = this.licenseKbCount >= 5;
        } catch (fallbackError) {
          if (this.formParam.license_id !== licenseId) return;
          this.licenseKbCount = 0;
          this.licenseLimitReached = false;
        }
      } finally {
        this.licenseKbLoading = false;
      }
    },
    inputFilterExtract(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Validasi License harus dipilih dulu sebelum upload
        if (this.licenseLimitReached) {
          this.$fire({
            title: "Batas Knowledge Base",
            text: "Lisensi ini sudah memiliki 5 KB. Hapus salah satu KB sebelum menambah file baru.",
            type: "warning"
          });
          return prevent();
        }
        if (!this.selectedLicense) {
          this.$fire({ title: "Peringatan", text: "Silahkan pilih License terlebih dahulu sebelum upload file.", type: "warning" });
          return prevent();
        }

        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) return prevent();
        if (/\.(php|html|js)$/i.test(newFile.name)) return prevent();
        if (newFile.size > 10 * 1024 * 1024) {
          this.$fire({ title: "Terlalu Besar", text: "Max file 10MB", type: "error" });
          return prevent();
        }
      }
    },

    inputFileExtract(newFile, oldFile) {
      if (newFile && oldFile) {
        if (newFile.active && !oldFile.active) {
          if (newFile.size < 1024) {
            this.$refs.uploadbcExtract.update(newFile, { error: "File Terlalu Kecil" });
          }
        }

        const response = newFile.response || {};
        const responseData = response.data || {};

        if (newFile.error && !oldFile.error) {
          this.$fire({
            title: "Upload Gagal",
            text: response.msg || responseData.msg || "File belum berhasil diunggah. Coba lagi.",
            type: "error"
          });
        }

        // KETIKA UPLOAD BERHASIL
        if (newFile.success && !oldFile.success) {
          const uploadedLicenseId = this.formParam.license_id;
          this.formParam.file_url = responseData.file_url || responseData.path || "";
          // Simpan metadata job sebelum form di-reset agar halaman induk dapat
          // langsung memantau antrean pemrosesan tanpa menebak status.
          const uploadMeta = {
            job_id: responseData.job_id || "",
            job_status: responseData.job_status || "",
            file_id: Number(responseData.kb_file_id || responseData.file_id || responseData.history_id) || 0,
            total_chunks: Number(responseData.total_chunks) || 0,
            file_name: newFile.name || "",
          };

          // Upload HTTP sukses berbeda dari pemrosesan Knowledge Base selesai.
          // Jika server tidak mengembalikan kb_file_id atau ekstraksi teks gagal,
          // jangan tampilkan notifikasi seolah dokumen sudah siap dipakai.
          const processingWarning = !!(responseData.text_error || !responseData.kb_file_id);
          this.$fire({
            title: processingWarning ? "File diunggah, teks belum siap" : "File berhasil diunggah",
            text: processingWarning
              ? "Server menerima file, tetapi pemrosesan teks Knowledge Base belum berhasil. Periksa status dokumen setelah daftar dimuat ulang."
              : "Dokumen sedang diproses di server. Status Knowledge Base akan diperbarui setelah pemrosesan selesai.",
            type: processingWarning ? "warning" : "success",
            timer: 2200
          }).then(() => {
            this.resetForm();
            this.$emit("uploaded", uploadedLicenseId, uploadMeta);
          });
        }
      }

      // Auto start upload jika sudah ada file dan license terpilih
      if (newFile && !oldFile && !this.$refs.uploadbcExtract.active && this.selectedLicense) {
        this.$refs.uploadbcExtract.active = true;
      }
    },

    formatSizes(bytes) {
      return formatSizes(bytes);
    }
  }
};
</script>

<style scoped>
.kb-upload-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  background: rgba(16, 24, 40, 0.55);
  padding: 28px 14px;
}
.kb-upload-modal {
  width: 100%;
  max-width: 760px;
  margin: auto;
  overflow: hidden;
  border: 1px solid rgba(16, 24, 40, 0.08);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 24px 64px rgba(16, 24, 40, 0.28);
}
.kb-upload-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #eef1f5;
  padding: 15px 18px;
}
.kb-upload-eyebrow {
  display: block;
  color: #98a2b3;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.kb-upload-title {
  margin: 2px 0 0;
  color: #172033;
  font-size: 18px;
  font-weight: 800;
}
.kb-upload-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: #f2f4f7;
  color: #667085;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}
.kb-upload-close:hover:not(:disabled) {
  background: #fff1ed;
  color: #b42318;
}
.kb-upload-close:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
.kb-upload-body {
  max-height: calc(100vh - 190px);
  overflow-y: auto;
  padding: 16px 18px;
}
.kb-upload-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid #eef1f5;
  background: #fbfcfe;
  padding: 11px 18px;
}
.kb-upload-footer-note {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #7b8ba3;
  font-size: 10px;
  line-height: 1.4;
}
.kb-upload-footer-note i {
  color: #e77f25;
}
@media (max-width: 575px) {
  .kb-upload-overlay {
    padding: 12px 8px;
  }
  .kb-upload-head,
  .kb-upload-body,
  .kb-upload-footer {
    padding-left: 13px;
    padding-right: 13px;
  }
  .kb-upload-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .kb-upload-footer .btn {
    width: 100%;
  }
}
.file-list {
  list-style: none;
  padding: 10px;
  border: 1px solid #ddd;
  margin-bottom: 5px;
  border-radius: 4px;
}

.upload-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.kb-limit-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  border: 1px solid #dce9ff;
  border-radius: 8px;
  background: #f5f9ff;
  color: #56708f;
  padding: 8px 10px;
  font-size: 12px;
}

.kb-limit-line.is-limit {
  border-color: #fde3b7;
  background: #fffaf0;
  color: #8a5a00;
}
</style>


// WEBPACK FOOTER //
// src/views/settings/historykbAdd.vue